import React from "react";
import "../css/whatsapp.css";

const WhatsAppFloat = () => {
  return (
    <a
      href="https://wa.me/1234567890"
      className="whatsapp-float material-shadow"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contact us on WhatsApp"
    >
      <svg viewBox="0 0 32 32" className="whatsapp-icon">
        <path
          d="M16.002 2.015c-7.712 0-13.985 6.273-13.985 13.988 0 2.449.638 4.845 1.846 6.953l-1.996 7.29 7.458-1.956c2.046 1.1 4.35 1.682 6.677 1.682 7.712 0 13.988-6.273 13.988-13.988 0-7.715-6.276-13.969-13.988-13.969zM16.002 27.568c-2.072 0-4.103-.556-5.882-1.611l-.422-.249-4.375 1.147 1.168-4.263-.274-.435c-1.16-1.84-1.774-3.965-1.774-6.16 0-6.386 5.197-11.583 11.586-11.583 6.39 0 11.586 5.197 11.586 11.583.003 6.387-5.196 11.571-11.613 11.571z"
          fill="#fff"
        />
        <path
          d="M22.378 18.236c-.349-.175-2.064-1.018-2.383-1.135-.319-.116-.552-.175-.785.175-.233.349-.9 1.135-1.103 1.368-.204.233-.408.262-.757.087-1.554-.775-2.673-1.378-3.705-2.904-.265-.393-.016-.58.156-.755.156-.156.349-.408.523-.611.175-.204.233-.349.349-.582.116-.233.058-.437-.029-.611-.087-.175-.785-1.892-1.076-2.59-.282-.681-.569-.588-.785-.598-.204-.01-.436-.01-.669-.01-.233 0-.611.087-.931.436-.32.349-1.222 1.193-1.222 2.909 0 1.716 1.251 3.374 1.425 3.607.175.233 2.463 3.762 5.964 5.275 2.113.913 2.87.973 3.967.828.932-.122 2.064-.843 2.355-1.657.291-.815.291-1.514.204-1.658-.088-.147-.32-.234-.669-.408z"
          fill="#fff"
        />
      </svg>
    </a>
  );
};

export default WhatsAppFloat;
